import { memo } from 'react';

import TriggerIcon from '@/assets/trigger-icon.svg?react';
import { Logo, LogoProps } from '@/components/core';
import {
  APILogo,
  EmailLogo,
  GoogleDriveLogo,
  MakeLogo,
  ManualLogo,
  MicrosoftOneDriveLogo,
  N8NLogo,
  PowerAutomateLogo,
  ZapierLogo,
} from '@/components/logos';
import {
  CREATE_AGENT_RUN_FROM_API_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_EMAIL_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_GOOGLE_DRIVE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_MAKE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_MANUAL_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_MICROSOFT_ONE_DRIVE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_N8N_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_POWER_AUTOMATE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_ZAPIER_FUNCTION_ID,
} from '@/constants';

export type TriggerLogoProps = LogoProps & {
  functionId?: string;
};

const ITriggerLogo = ({ functionId, ...rest }: TriggerLogoProps) => {
  switch (functionId) {
    case CREATE_AGENT_RUN_FROM_MANUAL_FUNCTION_ID:
      return <ManualLogo type="trigger" {...rest} />;
    case CREATE_AGENT_RUN_FROM_EMAIL_FUNCTION_ID:
      return <EmailLogo {...rest} />;
    case CREATE_AGENT_RUN_FROM_API_FUNCTION_ID:
      return <APILogo {...rest} />;
    case CREATE_AGENT_RUN_FROM_POWER_AUTOMATE_FUNCTION_ID:
      return <PowerAutomateLogo {...rest} />;
    case CREATE_AGENT_RUN_FROM_ZAPIER_FUNCTION_ID:
      return <ZapierLogo {...rest} />;
    case CREATE_AGENT_RUN_FROM_MAKE_FUNCTION_ID:
      return <MakeLogo {...rest} />;
    case CREATE_AGENT_RUN_FROM_N8N_FUNCTION_ID:
      return <N8NLogo {...rest} />;
    case CREATE_AGENT_RUN_FROM_MICROSOFT_ONE_DRIVE_FUNCTION_ID:
      return <MicrosoftOneDriveLogo {...rest} />;
    case CREATE_AGENT_RUN_FROM_GOOGLE_DRIVE_FUNCTION_ID:
      return <GoogleDriveLogo {...rest} />;
  }

  return (
    <Logo className="bg-primary-50 p-sm !border-none text-white" {...rest}>
      <TriggerIcon className="text-primary-500" />
    </Logo>
  );
};

export const TriggerLogo = memo(ITriggerLogo) as typeof ITriggerLogo;
